<template>
    <main id="register2-wrapper">
        <div id="register2page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'HCID', url: '/', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div id="card-register2" class="card mb-4">
                            <div class="card-body">
                                <h3 class="title">Daftar</h3>
                                <div class="form-group row">
                                    <div class="col">
                                        <label class="label-form" for="hp">No Telepon</label>
                                        <input type="number" class="form-control form-register2" id="hp" aria-describedby="hp" placeholder="Masukkan no telepon">
                                        <small id="hpHelp" class="form-text text-muted"></small>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col">
                                        <a class="btn" id="btn-next">Daftar</a>
                                    </div>
                                </div>
                                <div class="form-group row text-center">
                                    <div class="col">
                                        Sudah punya akun ? <a href="#" id="login-link">Login</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            mobile: false
        };
    },
    created() {
        this.mobile = isMobile;
    },
    methods: {}
};
</script>

<style scoped lang="scss">
#register2page{
    background: #000000;
    #card-register2{
        background: #FFFFFF;
        border-radius: 10px;
        // font-family: Inter;
    }
    .title{
        color: #000000;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
    }
    .label-form{
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 24px;
        color: #3F3F3F;
    }
    .form-register2{
        border-radius: 10px;
        border: 1px solid #DBDBDB;
        box-sizing: border-box;
    }
    ::placeholder {
       color: #727272;
       font-style: normal;
       font-weight: 300;
       font-size: 14px;
       line-height: 24px;
    }
    .btn{
        width:100%;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
    }
    #btn-next{
        background: #E61B33;
        color: #FFFFFF;
        border-radius: 10px;
    }
    #btn-register2-google{
        background: #4081EC;
        color: #FFFFFF;
        border-radius: 5px;
    }
    .divider{
        align-items:center;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #B4B4B4;
    }
    #login-link{
        color: #727272;
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
    }
    #google-img{
        max-width: 20px;
        background: #FFFFFF;
        border-radius: 5px;
    }
    #google-section{
        position: absolute;
        left: 25px;
        bottom:80px;
        z-index: 1;
        background-color:white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
    }
}
</style>
